import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const PaymentStatus = () => {
    const location = useLocation();
    const [message, setMessage] = useState("Checking payment status...");
    const [payuResponse, setPayuResponse] = useState(null);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const status = "Success";

        // Collect PayU response params
        const payuData = {};
        for (const [key, value] of queryParams.entries()) {
            payuData[key] = value;
        }
        setPayuResponse(payuData);

        // Save the response to server (optional)
        fetch("https://ecomplatformapi.erelatelabs.com/api/Product/SavePayUResponse", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payuData)
        }).catch(err => console.error("Failed to save PayU response", err));

        if (status === "success") {
            setMessage("✅ Payment Successful! Thank you.");
        } else if (status === "failure") {
            setMessage("❌ Payment Failed or Cancelled.");
        } else {
            setMessage("⚠️ Unknown payment status.");
        }
    }, [location]);

    return (
        <div className="container mt-5">
            <div className="alert alert-info text-center">
                <h4>{message}</h4>
            </div>

            {payuResponse && (
                <div className="card mt-3 p-3">
                    <h5>Transaction Details:Success</h5>
                    <ul className="list-group">
                        {Object.entries(payuResponse).map(([key, value]) => (
                            <li key={key} className="list-group-item">
                                <strong>{key}</strong>: {value}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default PaymentStatus;
